import { css } from '@emotion/react';
import { MODAL_BACKDROP } from '@core/components/testIds';
/**
 * Backdrop component for common/Modal
 */
export const Backdrop = ({ children, backdropCss, onClick }) => {
    return (<div data-testid={MODAL_BACKDROP} css={css `
        background: linear-gradient(
          180deg,
          rgb(0 0 0 / 40%) 0%,
          rgb(0 0 0 / 100%) 100%
        );

        overflow: hidden;
        height: 100%;
        width: 100%;
        position: absolute;
        left: 0;
        top: 0;
        ${backdropCss ?? ''}
      `} onClick={onClick}>
      {children}
    </div>);
};
